// extracted by mini-css-extract-plugin
export default {"timelineContainer":"Education_timelineContainer__aD9Ck","timelineLine":"Education_timelineLine__ZTtdq","timelineItem":"Education_timelineItem__rYlDW"};